import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BankAccount\GetBankAccountListController::__invoke
* @see app/Http/Controllers/BankAccount/GetBankAccountListController.php
* @route '/api/bank-account'
*/
const GetBankAccountListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBankAccountListController.url(options),
    method: 'get',
})

GetBankAccountListController.definition = {
    methods: ["get","head"],
    url: '/api/bank-account',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BankAccount\GetBankAccountListController::__invoke
* @see app/Http/Controllers/BankAccount/GetBankAccountListController.php
* @route '/api/bank-account'
*/
GetBankAccountListController.url = (options?: RouteQueryOptions) => {
    return GetBankAccountListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BankAccount\GetBankAccountListController::__invoke
* @see app/Http/Controllers/BankAccount/GetBankAccountListController.php
* @route '/api/bank-account'
*/
GetBankAccountListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBankAccountListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BankAccount\GetBankAccountListController::__invoke
* @see app/Http/Controllers/BankAccount/GetBankAccountListController.php
* @route '/api/bank-account'
*/
GetBankAccountListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetBankAccountListController.url(options),
    method: 'head',
})

export default GetBankAccountListController